import { COLORS } from "shared/consts";
import { toRem } from "shared/helpers";
import styled from "styled-components";

export const ChartWrapper = styled.div`
  display: flex;
  justify-content: center;
  overflow-x: auto;
  overflow-y: hidden;
  background-color: ${COLORS.ACCENT.CONTAINER_MUTED};
  border-radius: ${toRem(16)};
`;

export const Svg = styled.svg`
  display: block;
`;

export const Line = styled.path`
  fill: none;
  stroke: ${COLORS.ACCENT.DEFAULT};
  stroke-width: 2;
`;

export const Dot = styled.circle`
  r: 3;
  fill: ${COLORS.ACCENT.DEFAULT};
`;
